import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { normalizeInstalledPresets } from './normalize-installed-presets.js'
import { presetFiles } from './preset-files.js'

export function syncInstalledPresetManifests(cwd: string, config: ResolvedBetterstartConfig): void {
  presetFiles.syncInstalledManifests(cwd, config, normalizeInstalledPresets(config))
}
